module.exports = __webpack_public_path__ + "img/large3.df22e976.jpg";